import React from 'react';
import { ROUTE_BUILDING_SPECIFIC_COST_ESTIMATE } from '../../routes/Routes';
import SpecificCostEstimate from './SpecificCostEstimate';
import { getFeeTypeNameById } from '../../Enums/feetypes';

export default function BuildingSpecificCostEstimate() {
    const buildingFeeTypeFilter = getFeeTypeNameById(2);
    const {title} = ROUTE_BUILDING_SPECIFIC_COST_ESTIMATE;
 
    return <SpecificCostEstimate feeTypeFilter={buildingFeeTypeFilter} pageTitle={title} />
}